import type {
  DocEntityHandle,
  RoofEdgeHandle,
  RoofHandle,
  RoofSideHandle,
} from "building-types/handles/docEntityHandleTypes";

type RoofRelatedHandle = RoofHandle | RoofSideHandle | RoofEdgeHandle;

export function isRoofRelativeHandle(handle: DocEntityHandle): handle is RoofRelatedHandle {
  return (
    handle.type === "ROOF" || (handle.type === "EDGE" && handle.parent.type === "ROOF") || handle.type === "ROOF_SIDE"
  );
}

export function getRoofHandleAndEdgeIdFromHandle(handle: RoofRelatedHandle) {
  switch (handle.type) {
    case "ROOF": {
      return { roofHandle: { ...handle }, edgeId: undefined };
    }
    case "EDGE": {
      const id = handle.parent.id;
      return { roofHandle: { type: "ROOF", id }, edgeId: handle.edgeId };
    }
    case "ROOF_SIDE": {
      const id = handle.parent.id;
      return { roofHandle: { type: "ROOF", id }, edgeId: undefined };
    }
  }
}
